import {annotationSelection, annotationUuid} from "./data/model/index.js";
import {HIGHLIGHT_MARK_CLASS} from "./utils/highlight.js";

export const CLASSNAME_SPACE_APPENDED = "pn-space-appended";

const doesSelectionHaveText = function () {
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	if (!selection.rangeCount)
		return false;

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const textSelection = selection.toString().trim();
	if (!textSelection.length)
		return false;

	return true;
};

/**
 * Fix case when selection ends on start of an element but with nothing selected.
 */
const fixEmptyElementsOnSelection = function () {
	const selection = document.getSelection();

	if (!selection?.rangeCount)
		return;

	const range = selection.getRangeAt(0);
	const startNode = range.startContainer;
	const endNode = range.endContainer;
	const startOffset = range.startOffset;
	const endOffset = range.endOffset;

	if (!(endNode.nodeType === Node.ELEMENT_NODE && endOffset < 1))
		return;

	const prevEndNodeSibling = endNode.previousSibling;
	let newEndNode = null;
	let newEndOffset = null;

	if (!prevEndNodeSibling) {
		// @TODO: This should be improved and made recursive
		const endNodeParent = endNode.parentNode;
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const endNodeParentPrevSibling = endNodeParent.previousSibling;

		if (
			endNodeParentPrevSibling
			&& endNodeParentPrevSibling.nodeType === Node.TEXT_NODE
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
									&& !endNodeParentPrevSibling.textContent.trim().length
		) {
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			newEndNode = endNodeParentPrevSibling.previousSibling.lastChild;

			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			while (newEndNode.nodeType !== Node.TEXT_NODE && newEndNode.nodeType === Node.ELEMENT_NODE)
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
				newEndNode = newEndNode.lastChild;

		}
	} else if (prevEndNodeSibling.nodeType === Node.TEXT_NODE)
		newEndNode = prevEndNodeSibling;
	else if (prevEndNodeSibling.nodeType === Node.ELEMENT_NODE)
		return;

	if (!newEndNode)
		return;

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	newEndOffset = newEndNode.textContent.length - 1;
	// Remove current selection
	selection.removeAllRanges();
	// Replace by new selection
	const newRange = document.createRange();
	newRange.setStart(startNode, startOffset);
	newRange.setEnd(newEndNode, newEndOffset);
	selection.addRange(newRange);
};

const isSelectionValid = function () {
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const range = selection.getRangeAt(0);
	const startNode = range.startContainer;
	const endNode = range.endContainer;

	// Only allow selections with text nodes or element nodes that are not inputs or textareas
	// @ts-expect-error TS(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
	const isValidNode = function (node) {
		if (node.nodeType === Node.ELEMENT_NODE) {
			let testNode = node;
			while (testNode) {
				if (testNode.nodeName === "INPUT" || testNode.nodeName === "TEXTAREA")
					return false;

				testNode = testNode.firstElementChild;
			}
		} else if (node.nodeType !== Node.TEXT_NODE)
			return false;

		return true;
	};

	if (!isValidNode(startNode) || !isValidNode(endNode))
		return false;

	// Is selection inside the right menu.
	const startElement = startNode.nodeType === Node.ELEMENT_NODE ? startNode : startNode.parentElement;
	const endElement = endNode.nodeType === Node.ELEMENT_NODE ? endNode : endNode.parentElement;
	const isStartInsideRightMenu = !!(startElement as any).closest(".js-aa-right-menu");
	const isEndInsideRightMenu = !!(endElement as any).closest(".js-aa-right-menu");

	if (isStartInsideRightMenu || isEndInsideRightMenu)
		return false;

	return true;
};

/**
 * Add a space at the end of every <mark> element in the selection
 * (fixes issues where each word/line is in its own <mark>, common in PDFs)
 */
const fixPdfMarksOnSelection = function () {
// @ts-expect-error TS(2304) FIXME: Cannot find name 'PDFViewerApplication'.
	if (typeof PDFViewerApplication === "undefined")
		return; // Only do this for PDFs

	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const range = selection.getRangeAt(0);
	const startOffset = range.startOffset;
	const endOffset = range.endOffset;
	const commonAncestorContainer = range.commonAncestorContainer;
	if (commonAncestorContainer.nodeType !== Node.ELEMENT_NODE)
		return;

	(commonAncestorContainer as Element).querySelectorAll("mark:not(." + CLASSNAME_SPACE_APPENDED + ")").forEach(appendSpace);

	// What we did altering the text may have moved the selection, so we reset the offsets to the ones we read
	// before doing it.
	range.setStart(range.startContainer, startOffset);
	range.setEnd(range.endContainer, endOffset);
};

const isOnlyOneWordSelected = function () {
// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const textSelection = document.getSelection().toString().trim();

	// Check for normal spaces and non-breaking spaces
	const selectionHasSpaces = textSelection.includes(" ") || textSelection.includes(String.fromCharCode(160));
	return !selectionHasSpaces;
};

/*
 * Check that start and end have complete words.
 * This is used internally by render.js and also externally by the mobile app.
 */
const extendSelectionToWords = function () {
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const range = selection.getRangeAt(0);
	let startNode = range.startContainer;
	let endNode = range.endContainer;
	const startOffset = range.startOffset;
	const endOffset = range.endOffset;

	// Find start text node if it's currently an element node
	while (startNode.nodeType !== Node.TEXT_NODE)
	// @ts-expect-error TS(2322) FIXME: Type 'ChildNode | null' is not assignable to type ... Remove this comment to see the full error message
		startNode = startNode.firstChild;

	// Find end text node if it's currently an element node
	while (endNode.nodeType !== Node.TEXT_NODE)
	// @ts-expect-error TS(2322) FIXME: Type 'ChildNode | null' is not assignable to type ... Remove this comment to see the full error message
		endNode = endNode.firstChild;

	// Find new start offset:
	const newStartOffset = (function () {
		if (startOffset === 0)
			return startOffset;

		const text = startNode.textContent;
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const text1 = text.substring(startOffset);

		// Clean up all spaces at the left
		const cleanLeft = text1.replace(/^(\r\n|\n|\r|\s)+/, "");
		const diff = text1.length - cleanLeft.length;

		// Means the selection starts with spaces
		if (diff > 0)
			return startOffset + diff;

		// Find spaces at the beginning
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const text2 = text.substring(0, startOffset);

		// RegExp to find last space, breaklines and carriage return
		const findLastSpaceRe = /.*((\r\n|\n|\r|\s)+)/g;
		// Find for the very last index from matches
		let lastSpaceIndex;
		while (findLastSpaceRe.exec(text2))
			lastSpaceIndex = findLastSpaceRe.lastIndex;

		if (!lastSpaceIndex) {
			// Seems like the text was the first one but it is incompleted
			// If there are no spaces are at the beginning, then it is the first word
			if (/^\S/g.exec(text2)) lastSpaceIndex = 0;
		}

		// @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
		if (lastSpaceIndex < startOffset)
			return lastSpaceIndex;

		return startOffset;
	})();

	// Find new end offset:
	const newEndOffset = (function () {
		const text = endNode.textContent;
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const text1 = text.substring(0, endOffset);

		// Clean up all spaces at the right
		const cleanRight = text1.replace(/(\r\n|\n|\r|\s)+$/, "");
		const diff = text1.length - cleanRight.length;

		// Means the selection ends with spaces
		if (diff > 0)
			return endOffset - diff;

		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const text2 = text.substring(endOffset);

		// Find first match of space, breakline and carriage return.
		const findNextSpaceRe = /((\r\n|\n|\r|\s)+).*/g;

		let nextSpaceIndex = 0;
		const result = findNextSpaceRe.exec(text2);

		if (result) {
			// Get the index of the first match
			nextSpaceIndex = result.index;
		}

		// Increase the selection if the last word is incompleted.
		// nextSpaceIndex is 0 when it is completed.
		return endOffset + nextSpaceIndex;
	})();

	// Remove current selection
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	selection.removeAllRanges();
	// Replace by new selection
	const newRange = document.createRange();
	// @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
	newRange.setStart(startNode, newStartOffset);
	newRange.setEnd(endNode, newEndOffset);
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	selection.addRange(newRange);
};

/**
 * Returns an array of sibling nodes (including the element in question)
 * that share the same nodeName (tag name) as an element.
 *
 * @param  HTMLElement  element
 * @return array
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
const getSiblingElementsOfSameType = function (element) {
	const parentElement = element.parentElement;
	if (parentElement === null)
		return [];

	const sameTypeSibs = [];
	const siblings = parentElement.children;
	for (let i = 0; i < siblings.length; i++) {
		const s = siblings.item(i);
		if (s.nodeName.toLowerCase() === element.nodeName.toLowerCase())
			sameTypeSibs.push(s);
	}

	return sameTypeSibs;
};

/**
 * Get an element index relative to its parent container.
 *
 * @param   HTMLElement  element
 * @return  int
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
const getElementIndex = function (element) {
	const elems = getSiblingElementsOfSameType(element);
	let idx = 0;
	for (const elem of elems) {
		if (elem.classList.contains(HIGHLIGHT_MARK_CLASS))
			continue;

		idx++;

		if (elem === element)
			break;
	}

	return idx;
};

/**
 * Get an element string representation.
 * It includes in parenthesis its index.
 *
 * @param   HTMLElement  element
 * @return  string
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
const getElementStr = function (element) {
	const tag = element.tagName.toLowerCase();
	const idx = getElementIndex(element);

	return tag + "(" + idx + ")";
};

/**
 * Returns an object with a tree string representation of the position
 * where an element is, and an offset of where the node can be found.
 *
 * @param   object  node    Node from which to get the tree representation.
 * @param   int     offset  Offset of selection.
 * @return  object
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
const getElementTree = function (node, offset) {
	// Get parent element if it's a text node
	const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
	let parents = [];

	const parentsList = [];
	let curr = element.parentElement;
	while (curr !== null) {
		parentsList.push(curr);
		curr = curr.parentElement;
	}
	const newOffset = (function () {
		let child = node;
		const prevSiblings = [];
		let prevSiblingsStrLen = 0;

		// Save all nodes previous to the one that has the start/end.
		while ((child = child.previousSibling) != null)
			prevSiblings.push(child);

		// Reverse order in order to traverse correctly.
		prevSiblings.reverse();

		for (const nodeIte of prevSiblings)
			prevSiblingsStrLen += nodeIte.textContent.length;

		return offset + prevSiblingsStrLen;
	})();

	for (const parent of parentsList) {
		const tagName = parent.tagName.toLowerCase();

		// We don't need these tags.
		if (["html", "body"].includes(tagName))
			continue;

		parents.push(getElementStr(parent));
	}

	parents.reverse();
	parents.push(getElementStr(element));
	// @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'any[]'.
	parents = parents.join("/");

	return {
		str:    parents,
		offset: newOffset
	};
};

/**
 * Receives a single element, finds the leaves of the tree, and appends a space to each of them (and adds a class name).
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
const appendSpace = function (element) {
	if (element.children.length > 0) {
		// Not a leaf
		for (const elemChild of element.children)
			appendSpace(elemChild);
	} else {
		const lastChar = element.textContent.substr(-1);
		if (
			lastChar !== " " // the text already ends with a space
			&& lastChar !== "-" // this probably means a word cut in half (e.g. <div>rende-</div><div>ring</div>)
		) {
			if (element.childNodes.length === 1 && element.childNodes[0].nodeType === Node.TEXT_NODE)
				element.childNodes[0].nodeValue += " ";
			else
				element.textContent += " ";

			element.classList.add(CLASSNAME_SPACE_APPENDED);
		}
	}
};

//
// PUBLIC FUNCTIONS
//

/**
 * Returns an object with the correct node and offset for a selection
 * limit (start/end) from a tree string and offset that have no info
 * about other siblings.
 *
 * @param   {string}  treeStr  String representing path to a node.
 * @param   {int}     offset   Offset to find proper node.
 * @param   {string} position  start or end
 * @return  {object}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'treeStr' implicitly has an 'any' type.
const getCorrectNodeAndOffset = function (treeStr, offset, position) {
	if (!treeStr)
		return null;
	const node = (function () {
		const parts = treeStr.split("/");
		// Parse path from parts
		const path = (function () {
			const path = [];

			for (const part of parts) {
				const lpIdx = part.indexOf("(");
				const tag = part.substr(0, lpIdx);
				const idx = parseInt(part.substr(lpIdx).replace(/\(|\)/g, ""), 10);

				path.push({
					tag: tag,
					idx: idx - 1
				});
			}

			return path;
		})();

		// Walk all body nodes via path data.
		const body = document.body;
		let childNodesArr = Array.prototype.slice.call(body.childNodes);
		let finalNode = null;

		for (let i = 0; i < path.length; i++) {
			const tag = path[i].tag;
			const tagIdx = path[i].idx;
			let tagIdxCt = 0;
			let foundNode = null;

			for (const childNode of childNodesArr) {
				if (childNode.nodeType !== Node.ELEMENT_NODE)
					continue;

				const iteTag = childNode.tagName.toLowerCase();

				if (iteTag === tag) {
					if (childNode.classList.contains(HIGHLIGHT_MARK_CLASS))
						continue;

					if (tagIdxCt === tagIdx) {
						foundNode = childNode;
						break;
					} else {
						tagIdxCt++;
						continue;
					}
				}
			}

			// Can't find node.
			if (!foundNode)
				break;

			if (i < (path.length - 1)) {
				childNodesArr = Array.prototype.slice.call(
					foundNode.childNodes
				);
			} else
				finalNode = foundNode;

		}

		return finalNode;
	})();
	if (!node)
		return null;

	const childNodesArr = Array.prototype.slice.call(node.childNodes);
	// @ts-expect-error TS(7006) FIXME: Parameter 'nodes' implicitly has an 'any' type.
	const getFixedNodeIdxAndOffset = function (nodes, offset) {
		let len = 0;

		for (let i = 0; i < nodes.length; i++) {
			const node = nodes[i];
			const nodeStrLen = node.textContent.length;

			// If node has no text, we can bypass it.
			if (!nodeStrLen)
				continue;

			const start = len;
			len += nodeStrLen;
			const end = len;

			// If it's the start boundary and directly on a node boundary, have
			// it start at the start of the next node, rather than the end of this node
			if ((position === "start" && offset >= start && offset < end)
				|| (position === "end" && offset >= start && offset <= end)) {
				return {
					idx:    i,
					offset: offset - start
				};
			}
		}

		// Offset couldn't be found on nodes given.
		return null;
	};
	const fixedNodeIdxAndOffset = getFixedNodeIdxAndOffset(childNodesArr, offset);
	if (!fixedNodeIdxAndOffset)
		return null;
	if (!(fixedNodeIdxAndOffset.idx in childNodesArr))
		return null;

	const retNode = childNodesArr[fixedNodeIdxAndOffset.idx];
	if (!retNode)
		return null;

	return {
		node:   retNode,
		offset: fixedNodeIdxAndOffset.offset
	};
};

/**
 * Returns the first annotation uuid found if there are any existing annotations
 * for the given selection.
 * If the rendered annotation doesn't have an associated uuid for some reason,
 * "__unknown_uuid__" will be returned, such as in one of the test cases.
 */
const getNestedHighlight = function (selection: annotationSelection, uuid: annotationUuid | null = null): annotationUuid | null {
	if (!selection?.startTreeStr)
		return null; // We don't understand other selection methods here

	// Start
	const startData = getCorrectNodeAndOffset(
		selection.startTreeStr,
		selection.startOffset,
		"start"
	);
	if (!startData)
		return null;
	const startNode = startData.node;
	// End
	const endData = getCorrectNodeAndOffset(
		selection.endTreeStr,
		selection.endOffset,
		"end"
	);
	if (!endData)
		return null;
	const endNode = endData.node;

	// Common parent to both elements
	const range = new Range();
	range.setStartBefore(startNode);
	range.setEndAfter(endNode);
	const commonParent = range.commonAncestorContainer;

	let nestedHighlightUuid = null;
	// Walks all nodes in between the start and end nodes to check
	// if there are existing annotations.
	// @ts-expect-error TS(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
	const walk = function (node) {
		const nodeType = node.nodeType;
		const nodeVsStart = startNode.compareDocumentPosition(node);
		const nodeVsEnd = endNode.compareDocumentPosition(node);

		const isNodeOnlyPrecedingStart = nodeVsStart === Node.DOCUMENT_POSITION_PRECEDING;
		const isNodeOnlyPrecedingEnd = nodeVsEnd === Node.DOCUMENT_POSITION_PRECEDING;
		const isNodeOnlyFollowingStart = nodeVsStart === Node.DOCUMENT_POSITION_FOLLOWING;
		const isNodeOnlyFollowingEnd = nodeVsEnd === Node.DOCUMENT_POSITION_FOLLOWING;

		if (
			(isNodeOnlyPrecedingStart && isNodeOnlyPrecedingEnd)
			|| (isNodeOnlyFollowingStart && isNodeOnlyFollowingEnd)
		)
			return;

		if (nodeType === Node.ELEMENT_NODE) {
			const childNodes = node.childNodes;
			const isNodeAHighlight = node.classList.contains(HIGHLIGHT_MARK_CLASS);
			const isSameAnnotation = (function () {
				if (!uuid)
					return false;

				if (uuid === node.getAttribute("data-uuid"))
					return true;

				return false;
			})();

			if (isNodeAHighlight && !isSameAnnotation) {
				const nodeUuid = node.getAttribute("data-uuid");
				nestedHighlightUuid = nodeUuid ?? "__unknown_uuid__";
				return;
			}

			for (const childNode of childNodes)
				walk(childNode);

		}
	};

	walk(commonParent);

	return nestedHighlightUuid;
};

/**
 * Returns an object with data from the current text selection.
 *
 * @return  object
 */
const getCurrentSelection = function (): annotationSelection | null {
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	if (!selection.rangeCount)
		return null;

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const text = selection.toString().trim();
	if (!text.length)
		return null;

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	return getSelectionFromRange(selection.getRangeAt(0));
};

/**
 * Returns an object with data from a given range, used when a real text selection isn't available.
 *
 * @param  range  Range
 * @return  object
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'range' implicitly has an 'any' type.
const getSelectionFromRange = function (range) {
	// Start
	const startTreeData = getElementTree(range.startContainer, range.startOffset);
	const startTreeStr = startTreeData.str;
	const startOffset = startTreeData.offset;
	// End
	const endTreeData = getElementTree(range.endContainer, range.endOffset);
	const endTreeStr = endTreeData.str;
	const endOffset = endTreeData.offset;

	return {
		startTreeStr: startTreeStr,
		startOffset:  startOffset,
		endTreeStr:   endTreeStr,
		endOffset:    endOffset
	};
};

/**
 * Clears any text selection.
 */
const clearTextSelection = function () {
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	if (!selection.rangeCount)
		return;

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	selection.removeAllRanges();
};

// @ts-expect-error TS(7006) FIXME: Parameter 'languageRules' implicitly has an 'any' ... Remove this comment to see the full error message
const processAndValidateSelection = function (languageRules, bypassHighlightRules = false) {
// TODO: In general this is probably really inefficient-- each method seems to get the selection itself
	const selection = getCurrentSelection();

	// Check whether current selection has nested annotations,
	// previously added.
	if (selection && getNestedHighlight(selection)) {
		clearTextSelection();
		return false;
	}

	// First check if selection has any text
	if (!doesSelectionHaveText())
		return false;

	// Fix case when selection ends on start of an element but with nothing selected.
	if (!bypassHighlightRules)
		fixEmptyElementsOnSelection();

	// Check if selection is valid.
	if (!isSelectionValid())
		return false;

	// Add a space at the end of every DIV element in the selection
	// (fixes issues where each word/line is in its own DIV, common in PDFs)
	if (!bypassHighlightRules)
		fixPdfMarksOnSelection();

	// Check if only one word is selected
	if (!bypassHighlightRules && languageRules.shouldRequireMinSelection
		&& isOnlyOneWordSelected())
		return false;

	// check that start and end have complete words
	if (!bypassHighlightRules && languageRules.shouldCompleteWordSelection)
		extendSelectionToWords();

	return true;
};

const getSelectedText = function () {
	const selection = window.getSelection();
	const nbspRegex = new RegExp(String.fromCharCode(160), "g");
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const selectedText = selection.toString().trim().replace(nbspRegex, " ");
	return selectedText;
};

// @ts-expect-error TS(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
const getImageTreeStr = function (image) {
	return getElementTree(image, 0).str;
};

/**
 * If a temp selection is stored, and there is no active selection,
 * recovers from the stored one.
 * Recovers selection from the provided object.
 * See getCurrentSelection().
 *
 * @param {Object} tmpSelection
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'tmpSelection' implicitly has an 'any' t... Remove this comment to see the full error message
const recoverSavedSelection = function (tmpSelection) {
	if (!tmpSelection)
		return;
	if (!tmpSelection?.startTreeStr)
		return; // We don't understand other selection methods here

	// Create a range from the stored selection.
	const newRange = document.createRange();

	// Start
	const startData = getCorrectNodeAndOffset(
		tmpSelection.startTreeStr,
		tmpSelection.startOffset,
		"start"
	);
	if (!startData)
		return;
	const startNode = startData.node;
	const startOffset = startData.offset;
	// End
	const endData = getCorrectNodeAndOffset(
		tmpSelection.endTreeStr,
		tmpSelection.endOffset,
		"end"
	);
	if (!endData)
		return;
	const endNode = endData.node;
	const endOffset = endData.offset;

	// Set new range limits
	newRange.setStart(startNode, startOffset);
	newRange.setEnd(endNode, endOffset);

	// Check if there is a current selection, if there is one, it should
	// be equal to the stored one.
	const selection = document.getSelection();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	if (selection.rangeCount) {
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const currentRange = selection.getRangeAt(0);
		const crStartNode = currentRange.startContainer;
		const crStartOffset = currentRange.startOffset;
		const crEndNode = currentRange.endContainer;
		const crEndOffset = currentRange.endOffset;

		const areStartNodesEquals = crStartNode.isEqualNode(startNode);
		const areEndNodesEquals = crEndNode.isEqualNode(endNode);
		const areStartOffsetsEquals = crStartOffset === tmpSelection.startOffset;
		const areEndOffsetsEquals = crEndOffset === tmpSelection.endOffset;

		if (
			areStartNodesEquals
			&& areEndNodesEquals
			&& areStartOffsetsEquals
			&& areEndOffsetsEquals
		) {
			// Current selection is valid, nothing to recover.
			return;
		} else {
			// Possible error, we'll recover from the stored one.
			console.warn("Possible error with text selection.");
		}
	}

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	selection.removeAllRanges();
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	selection.addRange(newRange);
};

const selection = {
	ClearTextSelection:          clearTextSelection,
	GetCorrectNodeAndOffset:     getCorrectNodeAndOffset,
	GetCurrentSelection:         getCurrentSelection,
	GetImageTreeStr:             getImageTreeStr,
	GetSelectionFromRange:       getSelectionFromRange,
	GetSelectedText:             getSelectedText,
	GetNestedHighlight:          getNestedHighlight,
	ProcessAndValidateSelection: processAndValidateSelection,
	RecoverSavedSelection:       recoverSavedSelection
};

export default selection;

// Expose for testing purposes only
const __testFns = (process.env.NODE_ENV === "test")
	? {extendSelectionToWords, fixPdfMarksOnSelection, isSelectionValid, getCorrectNodeAndOffset,
		getCurrentSelection, getSelectedText, processAndValidateSelection, isOnlyOneWordSelected,
		doesSelectionHaveText, getElementTree, getSelectionFromRange, clearTextSelection}
	: undefined;

export {__testFns};
